<template>
	<div class="notice-info">
		<!-- 导航 -->
		<!-- <van-nav-bar
		  title="系统公告详情"
		  left-text="返回"
		  left-arrow
		  @click-left="goBack"
		/> -->
		<headerTemplate title="系统公告详情"></headerTemplate>

		<div class="notice-box">
			<h2 class="title">{{AnnounceInfo.amt_title}}</h2>
			<p>{{AnnounceInfo.amt_time}}</p>
			<p v-html="AnnounceInfo.amt_content">{{AnnounceInfo.amt_content}}</p>
		</div>
	</div>
</template>

<script>
	import { getAnnouncementView } from '../../../api/sale'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'NoticeInfo',
		components: {
			headerTemplate
		},
		data() {
			return {
				// 公告列表
				AnnounceInfo: []
			}
		},
		methods: {
			// 返回上一页
			goBack() {
				this.$router.go(-1)
			}
		},
		created() {
			getAnnouncementView(this.$route.params.InfoId).then(res => {
				this.AnnounceInfo = res.result
			}).catch(error => {
				alert(error.message)
			})
		}
	}
</script>

<style lang="scss" scoped>
	.notice-info {
		font-size: 14px !important;

		.notice-box {
			padding: 0 10px;

			h2 {
				text-align: center;
				margin: 10px 0;
				padding-bottom: 10px;
				border-bottom: 1px solid #dad2d2;
			}

			p {
				color: #606266;
				margin-bottom: 10px;
			}
		}
	}
</style>